import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/api";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await register(email, password, name);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 grain">
      <div className="w-full max-w-md fade-up">
        <Link to="/login" className="text-xs tracking-[0.3em] uppercase mb-12 inline-block" style={{color: "var(--text-secondary)"}}>
          ← BACK
        </Link>
        <p className="label-xs mb-2">New operator</p>
        <h2 className="font-serif text-4xl mb-10">Create account</h2>

        <form onSubmit={onSubmit} className="space-y-5" data-testid="register-form">
          <div>
            <label className="label-xs block mb-2">Name</label>
            <input data-testid="register-name-input" className="input-base"
              value={name} onChange={(e) => setName(e.target.value)} placeholder="Optional" />
          </div>
          <div>
            <label className="label-xs block mb-2">Email</label>
            <input data-testid="register-email-input" className="input-base" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="label-xs block mb-2">Password (min 6)</label>
            <input data-testid="register-password-input" className="input-base" type="password" required minLength={6}
              value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>

          {error && (
            <div data-testid="register-error" className="text-xs px-3 py-2"
              style={{background: "var(--loss-bg)", color: "var(--loss)", border: "1px solid var(--loss)"}}>
              {error}
            </div>
          )}

          <button data-testid="register-submit-button" type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? "Creating..." : "Create account →"}
          </button>
        </form>

        <p className="text-xs mt-8" style={{color: "var(--text-secondary)"}}>
          Already have one?{" "}
          <Link to="/login" data-testid="goto-login-link" className="underline" style={{color: "var(--text-primary)"}}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
